export const ACTION_CENTER_API_PATH = {
  MAILBOX_CONNECTIONS: '/action-center/mailbox-connections',
  SUMMARY: '/action-center/summary',
} as const;

export const ACTION_CENTER_ROUTE = {
  PATH: '/action-center',
  SEGMENT: 'action-center',
} as const;

export const getShopperEmailMailboxSyncRetryApiPath = (shopperEmailId: number) =>
  `/shop_requests/shopper-emails/${shopperEmailId}/retry-mailbox-sync`;

export const ACTION_CENTER_QUERY_KEY = {
  MAILBOX_CONNECTIONS: 'mailbox-connections',
  ROOT: 'action-center',
  SUMMARY: 'summary',
} as const;

export const ACTION_CENTER_ITEM_STATUS = {
  PENDING: 'pending',
} as const;

export const MAILBOX_CONNECTION_ACTION_TYPE = {
  NOT_AUTHENTICATED: 'mailbox_not_authenticated',
  NEEDS_RECONNECT: 'mailbox_needs_reconnect',
  SYNC_ERROR: 'mailbox_sync_error',
} as const;

export const MAILBOX_CONNECTION_ACTION = {
  CONNECT: 'connect_mailbox',
  RECONNECT: 'reconnect_mailbox',
  RETRY_SYNC: 'retry_mailbox_sync',
} as const;

export const MAILBOX_CONNECTION_ACTION_LABEL = {
  CONNECT: 'Connect',
  RECONNECT: 'Reconnect',
  RETRY_SYNC: 'Retry sync',
} as const;
